<template>
  <v-layout align-center justify-center>
    <v-card>
      <v-card-text>
        <v-layout class="mb-2" align-center column>
          <v-btn style="margin-left: -14px; margin-top: -12px;" flat icon absolute left to="Login">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <div style="background-color: rgb(1, 31, 54);
            border-radius: 100%;
            padding: 20px 10px;
            margin-bottom: 18px;">
            <img src="/static/favicon/login-icon.svg" width="70" alt="TBS Login">
          </div>
        </v-layout>
        <v-form class="pb-4" v-model="formValid" @submit.prevent="getPin" ref="form">
          <v-text-field
            label="PIN"
            v-model="pin"
            required
            autofocus
            :counter="4"
            :rules="[
              value => !!value || 'pin is required',
            ]"
            class="v-text-field-upper float-label"
          ></v-text-field>
          <v-btn
            fab
            class="mx-2"
            type="submit"
            style="background-color: rgb(1 82 145);
              position: absolute;
              left: calc(50% - 35px);
              right: 0px;"
            :loading="loading" @click="() => {}">
            <v-icon style="color: white;">chevron_right</v-icon>
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProgressBtn from './ProgressBtn';

export default {
  name: 'SettingProvider',
  data: () => ({
    pin: null,
    formValid: true,
    loading: false,
  }),
  components: {
    ProgressBtn,
  },
  computed: {
    ...mapGetters({
      currentPIN: 'Acacia/Models/PIN/Get',
    }),
  },
  methods: {
    ...mapActions({
      getPIN: 'SettingProvider/PIN/getByPIN',
      addSnackbarErrorHandler: 'addSnackbarErrorHandler',
    }),
    getPin() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.getPIN(String(this.pin).toUpperCase())
          .then(this.onSuccessful)
          .catch(this.onError);
      }
    },
    onSuccessful() {
      this.loading = false;
      this.$router.replace({ name: 'Login' });
    },
    onError(error) {
      this.loading = false;
      this.addSnackbarErrorHandler(error);
    },
  },
  watch: {
    pin(newValue, oldValue) {
      if (newValue && newValue.length > 4) {
        this.$nextTick(() => {
          this.pin = oldValue;
        });
      }
    },
  },
  created() {
    this.pin = this.currentPIN.pin;
  },
};
</script>

<style scoped>
  .card {
    width: 100%;
    max-width: 370px;
  }
</style>

<style>
  .input-group__messages + .input-group__counter {
    display: none;
  }
  .v-text-field-upper input {
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/SettingProvider.vue